import {isSpan, isTextBlock, type PortableTextBlock} from '@portabletext/schema'
import type {EditorContext} from '../editor/editor-snapshot'
import {getTextBlockText} from './util.get-text-block-text'

/**
 * @public
 */
export function isEmptyTextBlock(
  context: Pick<EditorContext, 'schema'>,
  block: PortableTextBlock | unknown,
) {
  if (!isTextBlock(context, block)) {
    return false
  }

  const onlyText = block.children.every((child) => isSpan(context, child))
  const blockText = getTextBlockText(block)

  return onlyText && blockText === ''
}
